export default __webpack_public_path__ + "static/media/AccessibilitySupportBadge.d20dbae0.svg";